import { render, staticRenderFns } from "./WritingAssistantComp.vue?vue&type=template&id=545a4b7c&scoped=true"
import script from "./WritingAssistantComp.vue?vue&type=script&lang=js"
export * from "./WritingAssistantComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545a4b7c",
  null
  
)

export default component.exports